export const getInactiveAccountIds = (state: RootState) => state.profile.inactiveAccountIds
